import { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { logout } from '@hobs/auth/actions';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

class Logout extends PureComponent {
  static propTypes = {
    logout: propTypes.func,
    history: propTypes.object,
    match: propTypes.object
  };

  componentDidMount() {
    this.props.logout().then(() => {
      const redirectPath = this.getRedirectPath();
      this.props.history.push(`/login${redirectPath}`);
    });
  }

  getRedirectPath() {
    return this.props.match.params.redirect ? `/${this.props.match.params.redirect}` : '';
  }

  render() {
    return null;
  }
}

function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(logout())
  };
}

export default connect(
  null,
  mapDispatchToProps
)(withRouter(Logout));
